import React, { useEffect, useState } from "react";


import DashboardMetrics from "./dashboard";
import { fetchLearningsDashboardReport, fetchLearningsInsightsReport, fetchLearningsLeaderboardReport, fetchLearningsPopularReport, fetchLearningsSkillsReport } from "src/redux/actions/coaching/reports";
import { MonthPicker } from "../monthPicker";
import { useDispatch } from "react-redux";
import LeaderboardReport from "./leaderboard";
import MostEnrolledReport from "./enrollments";
import InsightsReport from "./insights";
import { useSelector } from "react-redux";

import _ from "lodash";
import cx from "classnames";
import styles from "./learnings.module.scss";
import SkillsReport from "./skills";

const LearningsReport = () => {
  const dispatch = useDispatch();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [selectedMonth, setSelectedMonth] = useState(
    monthNames[new Date().getMonth()],
  );

  const user = useSelector((state: any) => _.get(state, "users.me.id", null));

  const handleMonthSelect = (month) => {
    setSelectedMonth(month);
  };

  const getStartAndEndDate = (monthName) => {
    const currentYear = new Date().getFullYear();

    // Convert month name to month index (0-based)
    const monthIndex = new Date(`${monthName} 1, ${currentYear}`).getMonth();

    // Start date of the month
    const startDate = new Date(currentYear, monthIndex, 1);

    // End date of the month (last day)
    const endDate = new Date(currentYear, monthIndex + 1, 0);

    return {
      startDate: startDate,
      endDate: endDate,
    };
  };

  useEffect(() => {
    const { startDate, endDate } = getStartAndEndDate(selectedMonth);

    const request = {
      page: 0,
      limit: 10,
      startDate: startDate,
      endDate: endDate,
      user: user,
    };

    dispatch(fetchLearningsDashboardReport(request));
    dispatch(fetchLearningsLeaderboardReport(request));
    dispatch(fetchLearningsPopularReport(request));
    dispatch(fetchLearningsInsightsReport(request));
    dispatch(fetchLearningsSkillsReport(request))
  }, [selectedMonth]);

  return (
    <div className={styles.container}>
      <MonthPicker selectedMonth={selectedMonth} onPick={handleMonthSelect} />
      <DashboardMetrics />
      <LeaderboardReport />
      <SkillsReport />
      <MostEnrolledReport />
      <InsightsReport />
    </div>
  );
};

export default LearningsReport;
